// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__W1SkO","containerBox":"Terms_containerBox__SIaZ8","wrapper":"Terms_wrapper__xUKJf","left":"Terms_left__RNa4c","eliOrder":"Terms_eliOrder__1+Cmf"};